import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Container, { ContainerProps } from '@material-ui/core/Container';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    paddingTop: theme.spacing(4),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6.25),
      paddingRight: theme.spacing(6.25),
      paddingBottom: theme.spacing(6.25),
      paddingLeft: theme.spacing(6.25),
    },
  },
});

const AppContainer = ({
  maxWidth = 'lg',
  children,
  ...props
}: ContainerProps) => (
  <Container {...props} maxWidth={maxWidth}>
    {children}
  </Container>
);

export default withStyles(styles)(AppContainer);
